app.controller('OrderCheckoutProcessingController', ['$rootScope', '$scope', '$state', '$stateParams', function ($rootScope, $scope, $state, $stateParams) {

    const orderID = $stateParams.order_id ? $stateParams.order_id : $rootScope.model.order.current_order._id;

    $rootScope.service.order.requestOrder(orderID, function (success, order, messages) {

        if (success && !order._errors) {
            //n.b. In practice, every time we reach this point it will be from a sagepay redirect.
            //In such a case when the site reloads, the first thing it will do is retrieve the order from the api that
            //matches the cached orderID we are also using here.
            //Because the order the API tells us about will have a '_status' of 'SUBMIT' rather than 'SAVED', the site will
            //treat it as an invalid order and create a new one.

            //That makes this startNewOrder function largely redundant here, but for readability it is useful to know that
            //here is where we would otherwise start a new order after an order has successfully been placed using sagepay.
            $rootScope.service.tracking.track_sale(order);
            $rootScope.service.order.startNewOrder();

            $state.go('myba.order-checkout-acknowledgement.entry', {order_id: orderID});
        } else {
            $state.go('myba.order-checkout.entry', {order_id: orderID});
        }
    });

}]);
